export const SALES_ANALYSIS_GET_GRADES = 'SALES_ANALYSIS_GET_GRADES';
export const SALES_ANALYSIS_GET_GRADES_LOADING =
  'SALES_ANALYSIS_GET_GRADES_LOADING';
export const SALES_ANALYSIS_GET_USERS = 'SALES_ANALYSIS_GET_USERS';
export const SALES_ANALYSIS_GET_USERS_LOADING =
  'SALES_ANALYSIS_GET_USERS_LOADING';
export const SALES_ANALYSIS_REPORT_ERRORS = 'SALES_ANALYSIS_REPORT_ERRORS';



// WEBPACK FOOTER //
// ./src/pages/salesanalysis/state/types.js